// eslint-disable-next-line import/no-extraneous-dependencies
import { Volume2 } from "lucide-react";

/**
 * Botão para reproduzir a frase completa
 * @param {Object} props
 * @param {Function} props.onClick - Função chamada ao clicar
 * @param {string} props.title - Título do botão
 */
export const PlayPhraseButton = ({ onClick, title = "Reproduzir frase completa" }) => (
  <button
    type="button"
    className="play-full-phrase-btn"
    onClick={onClick}
    title={title}
    style={{
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '4px'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'scale(1.1)';
      e.currentTarget.style.opacity = '1';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'scale(1)';
      e.currentTarget.style.opacity = '0.7';
    }}
  >
    <Volume2
      size={30}
      color="white"
      strokeWidth={3.5}
    />
  </button>
);
